import { forwardRef } from 'react';
import { LinkProps, Link as RRLink } from 'react-router';
import { twMerge } from 'tailwind-merge';

/**
 * A styled link component that uses react-router's Link component under the hood.
 * Typically used for external links.
 */
const Link = forwardRef<HTMLAnchorElement, Omit<LinkProps, 'discover'>>(
  ({ className, ...props }, ref) => (
    <RRLink
      ref={ref}
      // oxlint-disable-next-line react/jsx-props-no-spreading
      {...props}
      className={twMerge(
        'inline-flex max-w-fit items-center gap-1 text-brand hover:underline',
        className,
      )}
      data-component="corso-link"
      discover="none"
    />
  ),
);

Link.displayName = 'Link';

export default Link;
